import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import NorthEastRoundedIcon from '@mui/icons-material/NorthEastRounded'
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded'
import { AppDialog } from '../Common/AppDialog'
import { IconButton } from '../Common/IconButton'
import type { DataContext } from '../../types/aiChatSource'
import { serializeChatSourceContext } from '../../types/aiChatSource'

export const ChatSourceExpandModal = ({
  context,
  onClose,
  onChange,
  onOpenInChat,
}: {
  context: DataContext | null
  onClose: () => void
  onChange: (context: DataContext) => void
  onOpenInChat: (channelId: string, messageId?: string) => void
}) => {
  if (!context || context.kind !== 'chat') return null
  const messages = context.messages ?? []
  const updateMessages = (messageId: string) => {
    const nextMessages = messages.filter((message) => message.messageId !== messageId)
    onChange({
      ...context,
      messages: nextMessages,
      text: serializeChatSourceContext({
        id: context.id,
        channelId: context.channelId ?? '',
        channelName: context.channelName ?? context.label,
        messages: nextMessages,
        addedAt: Date.now(),
      }),
    })
  }
  return (
    <AppDialog
      open
      title={context.label}
      message={(
        <div className="chatSourceExpand">
          {messages.map((message) => (
            <div key={message.messageId} className="chatSourceExpandRow">
              <ChatBubbleOutlineRoundedIcon fontSize="small" />
              <div>
                <strong>{message.authorName}</strong>
                <p>{message.textContent}</p>
              </div>
              <IconButton
                size="sm"
                variant="tertiary"
                tone="danger"
                onClick={() => updateMessages(message.messageId)}
                label={`Remove ${message.authorName} message`}
                icon={<CloseRoundedIcon fontSize="inherit" />}
              />
              <IconButton
                size="sm"
                variant="tertiary"
                onClick={() => onOpenInChat(context.channelId ?? '', message.messageId)}
                label={`Open ${message.authorName} message in chat`}
                icon={<NorthEastRoundedIcon fontSize="inherit" />}
              />
            </div>
          ))}
          {messages.length === 0 ? <p className="chatSourceExpandEmpty">No messages left in this bundle.</p> : null}
        </div>
      )}
      onDismiss={onClose}
      actions={[
        { label: 'Close', onClick: onClose },
      ]}
    />
  )
}
